
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: 'InputErrors',
    props: {
        errors: {
            type: Object as PropType<Record<string, string[]>>,
            required: true,
        },
    },
});
